// extracted by mini-css-extract-plugin
export default {"groupName":"GroupName_groupName__mV2Iw","groupName__title":"GroupName_groupName__title__eklOE","groupName__link":"GroupName_groupName__link__iSJqv"};